import { IRoundTeesAssignation } from '../store';

import api, { request } from '../../../api';
import { IStore } from '../../index';

const createRoundTee = async (
  state: IStore,
  clubId: number,
  eventId: number,
  roundId: number,
  roundTeeAssignation: IRoundTeesAssignation
) => {
  const assignation = {
    ...roundTeeAssignation,
    tee: roundTeeAssignation.tee ? roundTeeAssignation.tee.id : null
  };

  if (roundTeeAssignation.id < 0) {
    delete assignation.id;
  }

  const response = await request.post(api.roundTees(clubId, eventId, roundId), assignation);

  return response.error
    ? { error: { roundTees: 'The assignation could not be made' } }
    : { roundTees: { assignation: [...state.roundTees.assignation, roundTeeAssignation] } };
};

export default createRoundTee;
